import React from 'react'
import classNames from "classnames";
import getTitle from "../../../../helpers/getTitle";
import {Image} from "antd";
import {ImagePlaceholder} from "../../../../conts/imageBase64";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {DetailModalContent} from "../../../AppLocals/Church/components/ChurchForm";
import DrawDialog from "../../../../components/drawer/dialog/DrawDialog";
import {ChurchScenePlaceholder} from "../../../../components/Svgs/CatholicPlaceholderSvg";
import {GoLocation} from "react-icons/go";

export const UserCheckinCardItem = ({item, onClick, Wrapper = 'div', className}) => {
    const {owner, checkin_time} = item ?? {}
    const place_name = getTitle(item?.owner) || item?.name;
    const user = getTitle(item?.user)

    return (
        <Wrapper
            className={classNames("flex flex-center rounded-lg relative", className)}>
            <div className="flex items-center gap-3 p-3 w-full">
                {/* Photo — falls back to a church illustration instead of the generic image icon */}
                <div style={{width: 72, height: 72}} className="relative flex-shrink-0 rounded-lg overflow-hidden background-200">
                    {owner?.photo ? (
                        <Image
                            src={owner.photo}
                            fallback={ImagePlaceholder}
                            style={{width: '100%', height: '100%'}}
                            wrapperStyle={{width: '100%', height: '100%'}}
                            wrapperClassName="w-full h-full"
                            className="object-cover"
                            preview={false}
                        />
                    ) : (
                        <ChurchScenePlaceholder width="100%" height="100%" borderRadius={0}/>
                    )}
                </div>

                {/* Nội dung */}
                <div className="flex-1 min-w-0 flex flex-col gap-1">
                    <DrawDialog
                        width={600}
                        title={
                            <div className="text-center font-bold text-base text-color-000 leading-snug no-underline max-lines-1">
                                {place_name}
                            </div>
                        }
                        closable={false}
                        component={
                            <span className="font-bold text-sm text-color-000 leading-snug tracking-wide truncate block cursor-pointer hover:text-primary transition-colors">
                                {place_name}
                            </span>
                        }>
                        {(isToggle) => isToggle && (
                            <DetailModalContent
                                item={owner}
                                reportAccess={false}
                            />
                        )}
                    </DrawDialog>
                    <div className="flex items-center gap-1.5 min-w-0 text-xs text-color-300 tracking-wide">
                        <GoLocation size={11} className="text-primary flex-shrink-0"/>
                        <span className="font-semibold text-primary truncate">{user}</span>
                        <span className="text-color-400 flex-shrink-0">·</span>
                        <time className="flex-shrink-0">{formatSimplifyDate(checkin_time, 'fullTime')}</time>
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}
